
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const DistributorsPage = lazy(() => import('../pages/distributors/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/quote',
    element: <QuotePage />,
  },
  {
    path: '/distributors',
    element: <DistributorsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
